import type { ReactNode } from "react";

/**
 * Right-hand slide-over housing the assistant conversation. The workspace
 * is editor-first — prompting is a feature — so the transcript lives here,
 * out of the way until the user asks for it (via "View output" while a
 * generation runs, or the Output button any time after).
 */
export function AssistantDrawer({
  open,
  onClose,
  children,
}: {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}) {
  if (!open) return null;

  return (
    <>
      {/* Scrim — click to dismiss. Quiet, not a modal blackout. */}
      <div
        className="fixed inset-0 z-40 bg-black/20"
        onClick={onClose}
        aria-hidden
      />
      <aside className="fixed inset-y-0 right-0 z-50 flex w-full max-w-[520px] flex-col border-l border-line bg-surface shadow-xl">
        <div className="flex shrink-0 items-center justify-between border-b border-line px-4 py-3">
          <span className="text-sm font-semibold text-ink">Assistant</span>
          <button
            onClick={onClose}
            aria-label="Close assistant panel"
            className="rounded-lg p-1.5 text-ink-3 transition-colors hover:bg-surface-3 hover:text-ink"
          >
            <svg
              className="h-4 w-4"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              aria-hidden
            >
              <path strokeLinecap="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="flex min-h-0 flex-1 flex-col">{children}</div>
      </aside>
    </>
  );
}
